import { ParkingTimeSlot } from '@services/fleet-vehicle';
import { ParkArea } from '@services/park-area';

export class ParkingAreaInfrastructure {
	parkArea: ParkArea;
	bottleneck: ParkingTimeSlot;
	voltaageRecommendationACChargers: number;
	eProToInstall: number;
	powerUsedByChargingIncludingFast: number;
	delta: number;
	powerAvailableForEachSocketExcludingFast: number;
	powerAvailableForEachSocketIncludingFast: number;
	sumOfChargingTime: Record<ParkingTimeSlot, number>;
	sumOfParkingTime: Record<ParkingTimeSlot, number>;
	sumOfParkingSlot: Record<ParkingTimeSlot, number>;
	numberOfCarsChargerCanServe: Record<ParkingTimeSlot, number>;
	numberOfChargersInstall: Record<ParkingTimeSlot, number>;

	actualParkingArea?: ParkArea;

	get parkingAreaId() {
		return this.parkArea.id;
	}

	get parkingAreaName() {
		return this.actualParkingArea?.name || this.parkArea.name;
	}

	get numberOfParkingSlots() {
		return this.actualParkingArea?.parkingSlotsNumber || this.parkArea.parkingSlotsNumber;
	}

	get acInstalled() {
		return this.actualParkingArea?.currentACInstalled || this.parkArea.currentACInstalled || 0;
	}

	get dcInstalled() {
		return this.actualParkingArea?.currentDCInstalled || this.parkArea.currentDCInstalled || 0;
	}

	get acToBeInstalled() {
		return this.actualParkingArea?.finalACToBeInstalled || this.parkArea.finalACToBeInstalled || 0;
	}

	get dcToBeInstalled() {
		return this.actualParkingArea?.finalDCToBeInstalled || this.parkArea.finalDCToBeInstalled || 0;
	}

	get cpoToBeInstalled() {
		return this.actualParkingArea?.finalCPOToBeInstalled || this.parkArea.finalCPOToBeInstalled || 0;
	}
}
